module.exports = "/_next/static/images/0a4457682571d555552170e07dbf29cd-hero-belinda-mobile.jpg.webp";